import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log("React.error", { error, errorInfo }, "error");
  }

  render() {
    if (this.state.hasError) {
      return <>Ocurrió un error</>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
